<template>
    <template v-if="hasData">
        <BudgetedHoursRow :budget="budget" :roster="roster" :budgetDayCounters="budgetDayCounters" type="amount" />
        <BudgetedHoursRow :budget="budget" :roster="roster" :budgetDayCounters="budgetDayCounters" type="used" />
        <BudgetedHoursRow :budget="budget" :roster="roster" :budgetDayCounters="budgetDayCounters" type="sum" />
    </template>
</template>

<script lang="ts">
    import {RosterData, BudgetDayCounters} from '@/types/types';
    import {Budget} from '@cquential/api';
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import BudgetedHoursRow from '@/components/Planbord/Budget/BudgetedHoursRow.vue';

    @Component({
        components: {
            BudgetedHoursRow,
        },
    })
    export default class BudgetBody extends Vue {
        @Prop({required: true}) public roster!: RosterData;
        @Prop({required: true}) public budget!: Budget;
        @Prop({required: true}) public budgetDayCounters!: BudgetDayCounters;

        public get hasData(): boolean {
            return this.budget.id !== undefined
                && Object.keys(this.budgetDayCounters).length > 0
                && this.budgetDayCounters[this.budget.id] !== undefined;
        }
    }
</script>
